import { createHttpClient } from '@adapters/HttpClient';
import type { HttpClient } from '@adapters/HttpClient/types';
import { apiClientWH } from '@shared/services/ApiClient';

// ========================================
// INTERFACES
// ========================================

export interface ImportManualOrderRequest {
  shop_id: number;
  since_id: string;
}

export interface ImportManualOrderResponse {
  success: boolean;
  message?: string;
  // Otros campos que pueda devolver la API
}

// ========================================
// ADAPTER
// ========================================

export class OrdersImportApiAdapter {
  private httpClient: HttpClient;

  constructor(httpClient?: HttpClient) {
    this.httpClient = httpClient ?? createHttpClient(apiClientWH);
  }

  async importManualOrder(
    data: ImportManualOrderRequest
  ): Promise<ImportManualOrderResponse> {
    const response = await this.httpClient.post<ImportManualOrderResponse>(
      '/orders/import-manual',
      data,
      {},
      true // Mostrar loading global
    );

    // Si la API devuelve un 200 OK con un cuerpo vacío {}, response.success será undefined.
    // En este caso, lo consideramos un éxito.
    if (response && typeof response.success === 'undefined') {
      return { success: true, ...response };
    }

    return response;
  }
}
